import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import SourceBaseBox from "../layout/SourceBaseBox";

export default memo(({ id, data, selected, isConnectable }) => {
  return (
    <SourceBaseBox
      title={BoxTitles.ImportedAudience}
      valid={BoxValidations.validate(BoxTypes.ImportedAudience, data)}
      selected={selected}
      isConnectable={isConnectable}
      footer={() => {}}
    >
      {data?.name && <div className={style.subline}>{data?.name}</div>}
    </SourceBaseBox>
  );
});
